export const track = analytics => {
  const { eventCategory, eventAction, eventLabel, eventValue } = analytics;
  analytics &&
    window.gtag &&
    window.gtag("event", eventAction, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue
    });
};

export const trackingWrapper = (type, action, trackingObject) => {
  
  const { event_category, event_label, label } = trackingObject;

  const data = {action, label, category: event_category, label: event_label};

  track({eventAction: 'Affiliate_' + action, eventLabel: label, eventCategory: 'affiliate-' + event_category});
};


// WEBPACK FOOTER //
// ./src/js/utils/analytics.js